<template>
  <div>
    <banner/>
    <div class="content">
      <tabs v-bind:titleSearch="titleSearch"/>
      <module1/>
    </div>
  </div>
</template>

<script>
  import MyPlayer from '@/components/myPlayer'
  import Banner from '@/components/banner/index'
  import Tabs from '@/components/tabs/index'
  import Module1 from '@/components/module-1/index'
    export default {
      name: "AppMain",
      components:{MyPlayer,Banner,Tabs,Module1},
      props:["titleSearch"]
    }
</script>

<style scoped>
.content{
  width: 1200px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue